export const Typographie = {
  fontFamily: "Inter, sans-serif",
};
